import { Link } from "react-router-dom";
import { Facebook, Instagram, Twitter } from "react-feather";

const CourierDeliveryTemplate = ({ data, isStickyHeader }) => {

    return (<div style={{ fontFamily: "Arial, sans-serif", background: "#f5f5f5", color: "#111" }}>
        <header style={{ background: "#006b2d", position: isStickyHeader ? "sticky" : "relative", top: 0, zIndex: 999, width: "100%", boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }}>
            <div style={{ maxWidth: "1400px", margin: "0 auto", padding: "18px 40px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ width: '200px', height: 'auto' }}>
                    <img src={data && data?.logoURL ? data?.logoURL : "/images/logo.svg"} alt="logo" style={{ maxHeight: '67px' }} />
                </div>

                <nav style={{ display: "flex", gap: "30px", alignItems: "center" }}>
                    <Link to={"/sign-in"} style={navLink}>Sign In</Link>
                    <Link to={"/track-booking"} style={navLink}>Track</Link>
                    <button style={{ background: "#fff", color: "#006b2d", border: "none", padding: "12px 20px", fontWeight: "bold", cursor: "pointer" }}>📞 {data && data?.phone ? data?.phone : ""}</button>
                </nav>
            </div>
        </header >

        <section style={{ background: `linear-gradient(90deg,#ffffff 5%, rgba(255,255,255,0.2)), url(${data?.bannerImage ? data.bannerImage : "/images/template2-banner.png"})`, backgroundSize: "cover", backgroundPosition: "top center", minHeight: "650px", display: "flex", alignItems: "center" }}>
            <div style={{ maxWidth: "1400px", margin: "0 auto", width: "100%", padding: "0 40px" }}>
                <div style={{ maxWidth: "600px" }}>
                    <h1 style={{ fontSize: "72px", lineHeight: "82px", marginBottom: "20px" }}>{data && data?.heroTitle ? data?.heroTitle : ""}</h1>
                    <h3 style={{ fontSize: "30px", marginBottom: "20px" }}>{data && data?.heroSubTitle ? data?.heroSubTitle : ""}</h3>
                    <p style={{ fontSize: "22px", lineHeight: "38px", color: "#444" }}>{data && data?.heroDescription ? data?.heroDescription : ""}</p>
                    <button style={{ marginTop: "35px", background: "#006b2d", color: "#fff", border: "none", padding: "18px 35px", fontSize: "18px", cursor: "pointer" }}>Track Your Shipment</button>
                </div>
            </div>
        </section>

        <section style={{ padding: "80px 0", background: "#eef3ee" }}>
            <div style={{ maxWidth: "1400px", margin: "0 auto", padding: "0 40px", textAlign: "center" }}>
                <h2 style={{ fontSize: "44px", marginBottom: "40px" }}>Track Your Shipment</h2>
                <div style={{ display: "flex", justifyContent: "center", gap: "15px", flexWrap: "wrap" }}>
                    <input type="text" placeholder="Enter Tracking Number" style={{ width: "500px", padding: "18px", border: "1px solid #ddd", fontSize: "18px" }} />
                    <button style={{ background: "#006b2d", color: "#fff", border: "none", padding: "18px 35px", fontSize: "18px", cursor: "pointer" }}>🔍 Track Now</button>
                </div>
            </div>
        </section>

        <section style={{ padding: "100px 0", background: "#fff" }}>
            <div style={{ maxWidth: "1400px", margin: "0 auto", padding: "0 40px" }}>
                <h2 style={{ textAlign: "center", fontSize: "46px", marginBottom: "70px" }}>{data && data?.serviceTitle ? data?.serviceTitle : ""}</h2>
                <div style={{ display: "flex", gap: "30px" }}>
                    {data?.services.map((item, index) => (<div key={index} style={{ background: "#f5f7f5", padding: "45px 30px", textAlign: "center", border: "1px solid #e5e5e5" }}>
                        <div style={{ width: "90px", height: "90px", borderRadius: "50%", background: "#dff0e4", display: "flex", justifyContent: "center", alignItems: "center", margin: "0 auto 25px", fontSize: "42px" }}><img src={item?.icon} alt="icon" /></div>
                        <h3 style={{ fontSize: "28px", marginBottom: "15px" }}>{item.title}</h3>
                        <p style={{ color: "#666", fontSize: "18px", lineHeight: "32px" }}>{item.description}</p>
                    </div>))}
                </div>
            </div>
        </section>

        <section style={{ padding: "100px 0", background: "#f7f9fc" }}>
            <div style={{ maxWidth: "1400px", margin: "0 auto", padding: "0 40px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "70px", alignItems: "center" }}>
                <div>
                    <h2 style={{ fontSize: "56px", marginBottom: "30px", lineHeight: "68px" }}>{data && data?.aboutTitle ? data?.aboutTitle : ""}</h2>
                    <p style={{ fontSize: "21px", lineHeight: "40px", color: "#555" }}>{data && data?.aboutDescription ? data?.aboutDescription : ""}</p>
                </div>
                <div>
                    <img src={data && data?.aboutImage ? data?.aboutImage : "/images/template1-image.jfif"} alt="warehouse" style={{ width: "100%", objectFit: "cover" }} />
                </div>
            </div>
        </section>

        <footer style={{ background: "linear-gradient(135deg,#111,#222)", color: "#fff", padding: "60px 0 25px" }}>
            <div style={{ maxWidth: "1400px", margin: "0 auto", padding: "0 40px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "40px" }}>
                    <div>
                        <h3 style={{ marginBottom: "20px", fontSize: "28px" }}>Contact Info</h3>
                        <p>📞 {data && data?.phone ? data?.phone : ""}</p>
                        <p>✉️ {data && data?.email ? data?.email : "admin@eflogistics.io"}</p>
                        <p>📍 {data && data?.address ? data?.address : ""}</p>
                    </div>

                    <div>
                        <h3 style={{ marginBottom: "20px", fontSize: "28px" }}>Follow Us</h3>
                        <div style={{ display: "flex", gap: "20px" }}>
                            <Link to={data && data?.facebookURL ? data?.facebookURL : "/"} target="_blank" style={socialIcon}><Facebook /></Link>
                            <Link to={data && data?.instagramURL ? data?.instagramURL : "/"} style={socialIcon}><Instagram /></Link>
                            <Link to={data && data?.twitterURL ? data?.twitterURL : "/"} style={socialIcon}><Twitter /></Link>
                        </div>
                    </div>
                </div>

                <div style={{ marginTop: "50px", borderTop: "1px solid rgba(255,255,255,0.2)", paddingTop: "20px", textAlign: "center", opacity: 0.8 }}>{data && data?.copyRightText ? data?.copyRightText : ""}</div>
            </div>
        </footer>
    </div >);
};

const navLink = {
    color: "#fff",
    textDecoration: "none",
    fontSize: "16px",
};

const socialIcon = {
    color: "#fff",
    textDecoration: "none",
    fontSize: "18px",
};

export default CourierDeliveryTemplate;